"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _default = function _default(_ref) {
  var sendTypingIndicator = _ref.sendTypingIndicator;
  return sendTypingIndicator;
};

exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJzZW5kVHlwaW5nSW5kaWNhdG9yIl0sInNvdXJjZVJvb3QiOiJjb3JlOi8vLyIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3NlbGVjdG9ycy9zZW5kVHlwaW5nSW5kaWNhdG9yLnRzIl0sInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB0eXBlIHsgUmVkdXhTdGF0ZSB9IGZyb20gJy4uL3R5cGVzL2ludGVybmFsL1JlZHV4U3RhdGUnO1xuXG5leHBvcnQgZGVmYXVsdCAoeyBzZW5kVHlwaW5nSW5kaWNhdG9yIH06IFJlZHV4U3RhdGUpOiBib29sZWFuID0+IHNlbmRUeXBpbmdJbmRpY2F0b3I7XG4iXSwibWFwcGluZ3MiOiI7Ozs7Ozs7ZUFFZTtFQUFBLElBQUdBLG1CQUFILFFBQUdBLG1CQUFIO0VBQUEsT0FBa0RBLG1CQUFsRDtBQUFBLEMifQ==